export default __webpack_public_path__ + "static/media/cardonzo1.46f97d6a.jpg";